<template>
  <div id="grid-repDetalles">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Reporte detalles validaciones</v-toolbar-title
        >
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <!-- @change="cambiaTipo()" -->
          <v-select
            v-model="tipoValue"
            item-text="nombre"
            item-value="code"
            :items="tipoSelect"
            label="Tipo"
          ></v-select>
        </v-flex>
        <v-flex xs12 md3>
          <v-textarea
            v-model="rutValue"
            label="RUTs: (Ej: xxxxxxxx-1, xxxxxxxx-2)"
            maxlength="500"
            counter
          ></v-textarea>
          <!-- <span>RUTs: (Ej: xxxxxxxx-1, xxxxxxxx-2):</span> -->
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaIniFormatted"
                label="Fecha de inicio"
                prepend-icon="event"
                @click="menu1 = !menu1"
                @blur="fechaIniValue = parseDate(fechaIniFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaIniValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaFinFormatted"
                label="Fecha de fin"
                prepend-icon="event"
                @click="menu2 = !menu2"
                @blur="fechaFinValue = parseDate(fechaFinFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaFinValue"
              @input="menu2 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData(true)"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <div id="app">
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th
                        v-for="(header, index) in headers"
                        :key="index"
                        :class="{
                          'sticky-first-row': index === index,
                          'sticky-first-column': index === 0,
                          'sticky-last-column': index === headers.length - 1,
                        }"
                        :nowrap="true"
                      >
                        {{ header }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in tableData"
                      :key="rowIndex"
                      :class="{
                        'sticky-last-row': rowIndex === tableData.length - 1,
                      }"
                    >
                      <td
                        v-for="(item, colIndex) in row"
                        :key="colIndex"
                        :class="{
                          'sticky-first-column': colIndex === 0,
                          'sticky-last-column': colIndex === row.length - 1,
                        }"
                        :nowrap="true"
                        :style="{
                          backgroundColor:
                            rowIndex === tableData.length - 1
                              ? colores[colIndex]
                              : '',
                        }"
                      >
                        {{ item }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- descarga informe -->
            <v-dialog v-model="loadingInforme" persistent max-width="390">
              <loading-descarga></loading-descarga>
            </v-dialog>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                v-if="botonDescarga == true"
                color="primary"
                @click="descargaInforme()"
              >
                Descarga informe
                <v-icon right dark>folder</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/Loading.vue";

export default {
  name: "grid-repDetalle",

  components: {
    AlertEmpty,
    Loading,
    LoadingDescarga,
  },

  data() {
    return {
      loadingInforme: false,
      loading: false,
      alerta: false,
      botonDescarga: false,
      idContrato: "",
      usuarioLoggedTipe: "",
      idUserLogged: "",

      tipoSelect: [
        { code: "pers", nombre: "VALIDADORES POR DÍA" },
        { code: "hora", nombre: "HORAS POR DÍA" },
      ],
      tipoValue: "pers",

      rutValue: "",
      menu1: false,
      fechaIniValue: "",
      fechaIniFormatted: null,
      menu2: false,
      fechaFinValue: "",
      fechaFinFormatted: null,

      headers: [], // Encabezados de la tabla
      tableData: [], // Datos de la tabla
      colores: [], // color para ultima fila de la tabla
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
    fechaIniValue(val) {
      this.fechaIniFormatted = this.formatDate(this.fechaIniValue);
    },
    fechaFinValue(val) {
      this.fechaFinFormatted = this.formatDate(this.fechaFinValue);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;

    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    this.tab = this.$store.getters.subTabSelectedStored;
    this.loadData(true);
  },
  mounted() {
    this.tipoValue = this.tipoSelect[0].code;
  },
  computed: {},
  methods: {
    descargaInforme() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Descarga_Reporte_Validacion.xlsx";
      let proceso = this.$store.getters.proSelectedStored;

      var url = "/reporteDetalle/descargaReporte/";
      let body = {
        idContrato: this.idContrato,
        fechaIni:
          this.fechaIniValue && this.fechaIniValue != null
            ? this.formatDate(this.fechaIniValue) + " 00:00"
            : null,
        fechaFin:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.formatDate(this.fechaFinValue) + " 23:59"
            : null,
        rut: this.rutValue,
        tipo: this.tipoValue,
      };
      axios
        .post(url, body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadReporteDetalle() {
      let body = {
        idContrato: this.idContrato,
        fechaIni:
          this.fechaIniValue && this.fechaIniValue != null
            ? this.formatDate(this.fechaIniValue) + " 00:00"
            : null,
        fechaFin:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.formatDate(this.fechaFinValue) + " 23:59"
            : null,
        rut: this.rutValue,
        tipo: this.tipoValue,
      };
      return await axios
        .post("/reporteDetalle/verReporte/", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log("st::error:" + JSON.stringify(error, null, 2));
            // console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadData(limpiar) {
      this.tableData = [];
      if (limpiar) this.page = 1;
      this.loading = true;

      let result = await this.loadReporteDetalle();

      if (result.totalRegistros > 0) {
        this.colores = result.colores;

        this.tableData = result.tableData;
        this.headers = result.headers;
        this.alerta = false;
        this.botonDescarga = true;
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
      } else {
        this.alerta = true;
        this.headers = [];

        this.totalRegs = 0;
        this.page = 1;
        this.pages = 0;
      }
      this.loading = false;
    },
    clear() {
      this.rutValue = "";
      this.menu1 = false;
      this.fechaIniValue = "";
      this.fechaIniFormatted = null;
      this.menu2 = false;
      this.fechaFinValue = "";
      this.fechaFinFormatted = null;
      this.loadData(true);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.table-container {
  /* max-height: 800px; /* Altura máxima de la tabla con scroll interno */
  /*max-width: 1600px; Ancho máximo de la tabla con scroll interno */
  overflow: auto; /* Agrega scroll vertical y horizontal si es necesario */
}

table {
  width: auto;
  border-collapse: collapse;
}

th,
td {
  /* border: 1px solid #615e60; */
  text-align: center;
  padding: 8px;
}
tr {
  border: 1px solid #615e60;
  /* padding: 8px; */
}

.sticky-first-column,
.sticky-last-column {
  position: sticky !important;
  background-color: #d7d6d7;
  font-weight: bold; /* Negrita */
}

.sticky-first-column {
  left: 0 !important;
  z-index: 300;
}

.sticky-last-column {
  right: 0;
}

.sticky-first-row {
  position: sticky;
  top: 0;
  z-index: 3;
  color: white;
  background-color: #4253ad;
}

.sticky-last-row td {
  position: sticky;
  bottom: 0;
  z-index: 3;
  /* background-color: #D6D6D6; */
  font-weight: bold; /* Negrita */
}

.sticky-first-row .sticky-first-column {
  left: 0 !important;
}

.sticky-first-row .sticky-last-column {
  right: 0;
}

.sticky-last-row .sticky-first-column {
  left: 0 !important;
}

.sticky-last-row .sticky-last-column {
  right: 0;
}
</style>
